/** Roblox Top Charts 下载列元数据（与表格列顺序一致，供弹窗与 Excel 共用） */

export const ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC = {
  PCU: 'roblox__pcu',
  FAVORITE: 'roblox__favorite_number',
  VISIT: 'roblox__visit_number',
  LIKE: 'roblox__like_number',
  UNLIKE: 'roblox__unlike_number',
  SERVER_SIZE: 'roblox__max_players',
} as const;

export const getRobloxTopChartsDownloadRatioKey = (metricKey: string): string =>
  `${metricKey}_ratio`;

export interface IRobloxTopChartsDownloadColumnMeta {
  showKey: string;
  labelKey: string;
  exportTitle: string;
  metric?: string;
  ratioMetric?: string;
  customField?: string;
  hasRatio?: boolean;
}

export const ROBLOX_TOP_CHARTS_DOWNLOAD_COLUMN_META: IRobloxTopChartsDownloadColumnMeta[] = [
  {
    showKey: 'pcu_show',
    labelKey: 'dbi_roblox_top_charts_metric_pcu',
    exportTitle: 'PCU',
    metric: ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.PCU,
    ratioMetric: getRobloxTopChartsDownloadRatioKey(ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.PCU),
    hasRatio: true,
  },
  {
    showKey: 'favorite_show',
    labelKey: 'dbi_roblox_top_charts_metric_favorites',
    exportTitle: 'Favorites',
    metric: ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.FAVORITE,
    ratioMetric: getRobloxTopChartsDownloadRatioKey(ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.FAVORITE),
    hasRatio: true,
  },
  {
    showKey: 'visit_show',
    labelKey: 'dbi_roblox_top_charts_metric_visits',
    exportTitle: 'Visits',
    metric: ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.VISIT,
    ratioMetric: getRobloxTopChartsDownloadRatioKey(ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.VISIT),
    hasRatio: true,
  },
  {
    showKey: 'like_show',
    labelKey: 'dbi_roblox_top_charts_metric_likes',
    exportTitle: 'Likes',
    metric: ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.LIKE,
    ratioMetric: getRobloxTopChartsDownloadRatioKey(ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.LIKE),
    hasRatio: true,
  },
  {
    showKey: 'unlike_show',
    labelKey: 'dbi_roblox_top_charts_metric_dislikes',
    exportTitle: 'Unlike',
    metric: ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.UNLIKE,
    ratioMetric: getRobloxTopChartsDownloadRatioKey(ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.UNLIKE),
    hasRatio: true,
  },
  {
    showKey: 'server_size_show',
    labelKey: 'dbi_roblox_server_size',
    exportTitle: 'Server Size',
    metric: ROBLOX_TOP_CHARTS_DOWNLOAD_METRIC.SERVER_SIZE,
    hasRatio: false,
  },
  {
    showKey: 'supported_features_show',
    labelKey: 'dbi_roblox_supported_features',
    exportTitle: 'Supported Features',
    customField: 'support_feature',
    hasRatio: false,
  },
  {
    showKey: 'roblox_genre_show',
    labelKey: 'dbi_roblox_genre',
    exportTitle: 'Roblox Genre',
    hasRatio: false,
  },
];
